<template>
  <div class="soar-container flex justify-center gap-y-2">
    <RegistrationForm class="w-full flex flex-col gap-y-4" @onSubmit="onSubmit">
      <template #title>
        <HeaderTypo>{{ $t('register') }} - {{ $t('establishmentServices') }}</HeaderTypo>
      </template>
      <template #info>
        <HeaderTypo as="h3" class="text-xl">{{ $t('establishmentRegistration') }}</HeaderTypo>
        <ul class="list-disc ps-12">
          <li>{{ $t('governmentalestablishments') }}</li>
          <li>{{ $t('privateestablishments') }}</li>
          <li>{{ $t('semiGovestablishments') }}</li>
        </ul>
        <span>{{ $t('registrationLinkNote') }}</span>
      </template>
    </RegistrationForm>
  </div>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth'
import RegistrationForm from '@/components/RegistrationForm/index.vue'

const authStore = useAuthStore()

const onSubmit = async (formValues) => {
  await authStore.registerUser(2, formValues)
}
</script>

<style lang="scss" scoped></style>
